import { memo, useEffect, useMemo, useRef, useState } from 'react';
import styles from './index.module.scss';
import { useStore } from '@/store';
import { getAssetUrl } from '@/utils/common';
import BackgroundAnimate from '@/components/BackgroundAnimate';
import { useSpring, animated } from 'react-spring';
import { useQueryPoetry } from '@/services/hooks';
import { LandmarkPoetryPlaceDetailType } from '@/store/types';
import { driveDigitalHumanBySpeak, driveDigitalHumanByText } from '@/pages/DigitalHuman/util/tts-manage';
import { getScenicDataInsights } from '@/services/get';
import { postionsList } from '../../dynasty';
import PoetryCard from './PoetryCard';
import _ from 'lodash';


const LandmarkPoetryDetail = () => {
  const { data } = useQueryPoetry();
  const [list, setList] = useState<any>([]);
  const placeId = useStore((state) => state.landmarkPoetryPlaceId);
  const placeType = useStore((state) => state.landmarkPoetryPlaceType);
  const placeAuthor = useStore((state) => state.landmarkPoetryPlaceAuthor);
  const scrollInterval = useRef<any>(null);
  const scrollContainer = useRef<any>(null);
  const curIndexRef = useRef<number>(0);
  const place = useMemo(() => {
    return data?.find((item: any) => item.entity_id === placeId);
  }, [data, placeId]);


  // 是否应该展示
  const shouldShow = placeType===LandmarkPoetryPlaceDetailType.POEM && !!placeId && !placeAuthor;
  // 是否展示了
  const isShow = placeType === LandmarkPoetryPlaceDetailType.POEM && !!place && !placeAuthor;

  // 语音控制
  useEffect(()=>{
    if(shouldShow&&!isShow){
      console.warn('未找到相关地标的诗词信息',placeId);
      driveDigitalHumanByText('未找到相关地标，你可以选择其他地标');
    }
    if (!isShow) return;
    if (place) {
      const xihuInsight = getScenicDataInsights(place.biz_info?.scenic_data_insights);
      if (xihuInsight) {
        driveDigitalHumanBySpeak(xihuInsight);
      }
    }
  },[isShow,shouldShow, place])


  const contentAnimate = useSpring({
    opacity: isShow ? 1 : 0,
    scale: isShow ? 1 : 0,
    config: {
      duration: 500,
    },
  });

  useEffect(() => {
    const placelist = place?.ext_neighborList.filter((item: any) =>
      item.vertex.label === "creative_work"
      && item?.edge?.tags?.includes('诗词地标')
      && item?.vertex?.tags?.includes('诗词精选')
      && item?.vertex?.summary?.trim() !== "").map((i: any, index: number) => ({
        ...i,
        position: postionsList[index % 8]
      }));
    const randomItems: any = _.chunk(placelist || [], 8);
    curIndexRef.current = 0;
    setList(randomItems[curIndexRef.current]);
    if (randomItems?.length > 0) {
      const timer = setInterval(() => {
        if (curIndexRef.current < randomItems?.length - 1) {
          curIndexRef.current += 1;
        } else {
          curIndexRef.current = 0;
        }
        setList(randomItems[curIndexRef.current]);
      }, 10000);


      return () => clearInterval(timer);
    }

  }, [place])

  function startAutoScroll() {
    scrollInterval.current = setInterval(() => {
      if (!scrollContainer.current) {
        return false;
      }
      const scrollDistance = 1;
      const currentScroll = scrollContainer.current.scrollTop;
      scrollContainer.current.scrollTop = currentScroll + scrollDistance;
      if (currentScroll >= scrollContainer.current.scrollHeight - scrollContainer.current.clientHeight) {
        scrollContainer.current.scrollTop = 0;
      }
    }, 80);
  }

  useEffect(() => {
    if (scrollContainer.current) {
      startAutoScroll();
    }
    return () => {
      clearInterval(scrollInterval.current);
      scrollInterval.current = null;
    };
  }, [scrollContainer.current]);

  const HighlightNumbers = (text: string) => {
    const parts = text?.split(/(\d+)/).filter(Boolean) || [];
    return (
      <>
        {parts.map((part, index) => (
          // 如果是数字，则用<span>包裹并应用样式
          <span key={index} style={{
            color: part.match(/^\d+$/) ? '#9D805D' : 'inherit',
            fontSize: part.match(/^\d+$/) ? '40px' : '29px',
            fontWeight: part.match(/^\d+$/) ? '800' : '400',
            textShadow: part.match(/^\d+$/) ? `-3px -3px 0 white,
            3px -3px 0 white,
            -3px 3px 0 white,
            3px 3px 0 white,
            0 0 0 white,
            0 0 0 white,
            0 0 0 white,
            0 0 0 white` : '',

          }}>
            {part}
          </span>
        ))}
      </>
    );
  }

  return isShow && (
    <BackgroundAnimate visible={true} opacity={0} loop={true}>
      <animated.div className={styles.content} style={contentAnimate}>
        <div className={styles.introduce}>
          {HighlightNumbers(place?.biz_info?.insights_highlights)}
        </div>
        <div className={styles.mid}>
          <div className={styles.circle}>
            <div className={styles.circle_container}>
              <div className={styles.name_img}
                style={{ backgroundImage: `url(${getAssetUrl("images/landmark/nameimg.png")})` }}
              >
                <img src={place.image} alt="" className={styles.temple} />
                <p className={styles.title}>{place.name}</p>
              </div>
            </div>
          </div>
          <div style={{ width: '1613px', height: '941px', position: "relative" }}>
            {list?.map((item: any, index: number) => (
              <PoetryCard item={item} index={index} key={item.vertex.entityId} />
            ))}
          </div>
        </div>
        {/* <div className={styles.left}>
          <img src={getAssetUrl("images/landmark/hangzhou.svg")} alt="" />
          <h2>{place.name}</h2>
          <div className={styles.description} ref={scrollContainer}>{place.summary}</div>
        </div> */}
      </animated.div>
    </BackgroundAnimate>
  );
};

export default memo(LandmarkPoetryDetail); 